<template>
  <div class="container">
    <div class="container p-4 main-container" id="pdf-content">
  <div class="page">
    <div class="row background-image">
      <div class="col-md-12 text-center content-overlay mb-5 mt-4" ref="contentOverlay">
        <img src="../../public/img/consagradas_logo2.png" class="img-fluid shadow-4-strong me-3 mb-4 mt-4" alt="Logo Consagradas" style="max-width: 36%;" />
        <br>

        <div v-if="form_update.img_thumb && form_update.img_thumb != 'null'" class="profile-image mx-auto" style="max-width: 250px !important; border-radius: 15px;">
          <img style="max-width: 250px !important; max-height: 250px;" :src="img_preview" alt="Perfil" />
        </div>
        
        <img v-else src="../../public/img/Perfil_default.png" class="img-fluid shadow-4-strong me-3 profile-image-default" style="max-width: 250px !important; border-radius: 15px;" alt="Perfil Default" />
        
        <br>
        <h3 class="name">{{ form_update.name }}</h3>
        <h5 class="member-since">{{ $t('member_since') }} {{ formatDate(form_update.date_consagration) }}</h5>
        <br>
        <a class="website">https://consagradasrc.org</a>
        <br>
        <vue-qr :text="config.value + '/' + form_update.code" :size="150" :margin="10"></vue-qr>
        <br>
        <p class="address">{{ form_update.address }}</p>
        <br>
      </div>
    </div>
  </div>

  <div class="page mt-5">
    <div class="row background-image">
    <div class="text-center p-3 mt-3 mb-5" style="line-height: 1 !important;">
        <h3 class="name">{{ $t('conditions_title') }}</h3>

<h5 class="section-title"><strong>{{ $t('terms.purpose_title') }}</strong></h5>
<p style="font-size: 12px;">{{ $t('terms.purpose_text') }}</p>

<h5 class="section-title"><strong>{{ $t('terms.conditions_title') }}</strong></h5>
<p style="font-size: 12px;">{{ $t('terms.conditions_text') }}</p>

<h5 class="section-title"><strong>{{ $t('terms.validity_title') }}</strong></h5>
<p style="font-size: 12px;">{{ $t('terms.validity_text') }}</p>

<h5 class="section-title"><strong>{{ $t('terms.responsibility_title') }}</strong></h5>
<p style="font-size: 12px;">{{ $t('terms.responsibility_text') }}</p>

<h5 class="section-title"><strong>{{ $t('terms.data_title') }}</strong></h5>
<p style="font-size: 12px;">{{ $t('terms.data_text') }}</p>
      </div>
    </div>
  </div>
</div>
  <div>
    <div class="row justify-content-center" >
      <div class="col-md-2 text-center">
    <multiselect 
      selectLabel='' 
      selectedLabel=""
      deselectLabel=''
      v-model="selectedLanguage" 
      :options="languages"
      placeholder="Language" 
      label="name" 
      track-by="code" 
      @input="changeLanguage" style="background-color: #f4f4f4; margin-top: 2px;"
    ></multiselect>
  </div>
  <div class="col-md-2 text-center">
    <button class="btn btn-primary mb-3" @click.prevent="generatePDF">Exportar a PDF</button>
  </div>
  </div>
</div>
  </div>
</template>
<script>
import Card from "src/components/Cards/Card.vue";
import { mapState } from "vuex";
import { mapActions } from "vuex";
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import es from "vue2-datepicker/locale/es";
import LTable from "src/components/Table.vue";
import moment from "moment";
import VueQr from 'vue-qr'
import i18n from "src/i18n.js";
import html2pdf from 'html2pdf.js';
import html2canvas from 'html2canvas';
import { jsPDF } from "jspdf";

import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
);

export default {
  components: {
    Card,
    Multiselect,
    FilePond,
    DatePicker,
    LTable,
    VueQr,
    i18n,
    html2pdf
  },
  data() {
    return {
      img_preview:'',
      window_title: "Detalle del Usuario",
      button_label: "Actualizar usuario",
      locale: { lang: "es", weekDays: ["L", "M", "M", "J", "V", "S", "D"] },
      countries: [],
      loaded: false,
      form_update: {
        name: "",
        email: "",
        phonePrefix: "",
        phone: "",
        address: "",
        studies: "",
        id_first_apostleship: "",
        type_user: "",
        community: "",
        nationality: "",
        birthDate: "",
        date_consagration: "",
        img: "",
      },
      //VARIABLE
      finder: "",
      metaInfo: {},
      TypeUsersTmp:[],
      IdRoleTmp:[],
      CommunityTmp:[],
      NationalityTmp:[],
      config:[],
      ApostleshipTmp:[],
      selectedLanguage: null,
      languages: [
        { name: 'English', code: 'en' },
        { name: 'Español', code: 'es' },
        { name: 'Italiano', code: 'it' },
        { name: 'Portugués', code: 'pt' },
        { name: 'Français', code: 'fr' },
        { name: 'Alemán', code: 'de' }
      ],
      tableData: {
        columns: [
          {
            name: "Nombre",
            key: "first_name",
          },
          {
            name: "Apellido",
            key: "last_name",
          },
          {
            name: "Fecha",
            key: "date",
          },
          {
            name: "Email",
            key: "email",
          },
          {
            name: "Telefono",
            key: "phone",
          },
          {
            name: "Acciones",
            key: "actions",
          },
        ],
        data: [],
      },
      //DATA Variables
      Users: [],
      //TABLE Buttons
      buttons: [
        {
          icon: "key",
          icon_negative: "key",
          type_button: "btn-info",
          tooltip: "Ver Detalles",
          url: "/admin/invitados/edit",
          type_action: "go_url",
          action: "go_url",
          class: "position-relative"
        },
        {
          icon: "pen",
          icon_negative: "pen",
          type_button: "btn-info",
          tooltip: "Cambiar Estatus",
          url: "",
          type_action: "go_method",
          action: "changeStatus",
          class: "position-relative"
        },
      ],
    };
  },
  mounted() {
    this.getElement(this.$route.params.code);
    this.loadConfig();
    DatePicker.locale("es", es);
    this.$nextTick(() => {
      this.adjustBackgroundHeight();
      window.addEventListener('resize', this.adjustBackgroundHeight);
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.adjustBackgroundHeight);
  },
  computed: {
    ...mapState({
      me: (state) => state.auth.me,
      me_rol: (state) => state.auth.me_rol,
    }),
    sortOptions() {
      return [];
    },
    rows() {
      return this.UsersTmp.length;
    },
  },
  methods: {

    formatDate(date) {
      return moment(date).format("YYYY");
    },

    ...mapActions(["getData", "updateData", "changeStatusData"]),
    changeLanguage(language) {
      i18n.locale = language.code;
    },
    getImageFromServer(id){
      var url_domain = window.location.host;
      var config_url = '';
      if (url_domain == 'localhost:8080') {
      config_url = 'http://localhost:3333/api/1.0'; 
      //config_url = 'https://apiconsagradas.myticktap.com/api/1.0';
      } else if (url_domain == 'https://apptest.consagradasrc.com/') {
        config_url = 'https://apiconsagradas.myticktap.com/api/1.0';    
      } 

      else if (url_domain == 'consagradas.myticktap.com') {
        config_url = 'https://apiconsagradas.myticktap.com/api/1.0';
      }
      else if (url_domain == 'dashmin.consagradasrc.com') {
        config_url = 'https://api.consagradasrc.com/api/1.0';
      }
      else if (url_domain == 'app.consagradasrc.com') {
  //New changes
  config_url = 'https://api.consagradasrc.com/api/1.0';
}
      //Fetch image witt get and fetch method
      fetch(config_url + '/user/view_image/' + id,{
      //Fetch image witt get and fetch method
         headers: {
          'Content-Type': 'image/jpeg',
          'tokentap':'Sb7qmGAxCrqdZz370F5cGSNrcQNidjQ2'
        }
      })
      .then(response => response.blob())
      .then(blob => {
        console.log(blob)
        const imageUrl = URL.createObjectURL(blob);
        this.img_preview = imageUrl;
      })
      .catch(error => {
        console.error('Error al cargar la imagen:', error);
      });

    },

    generatePDF() {
      const element = document.getElementById("pdf-content");

      // Opciones para html2pdf
      const options = {
        margin: [10, 10, 40, 10], 
        filename: `${this.form_update.name}${this.form_update.code}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: {
          dpi: 300, 
          letterRendering: true, 
          scale: 1, 
        },
        jsPDF: {
          unit: 'mm',
          format: 'a4',
          orientation: 'portrait',
          autoPaging: false, 
          putOnlyUsedFonts: true,
        },
      };

      html2pdf().from(element).set(options).save();
    },
  
    loadConfig() {
      let form = {
        url: "config/variable/qr_base_url",
        params: {
          active: 1,
          order_key: "id",
          order_value: "desc",
        },
      };

      this.isBusy = true;
      this.getData(form)
        .then((response) => {
          this.isBusy = false;
          if (response.code === 200) {
            this.config = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    formatDate(date) {
      return moment(date).format("YYYY");
    },

    getElement(code) {
      this.loaded = false;
      let data_params = {
        url: "public/user/code/" + code,
        params: {
          active: 1,
          order_by: "id",
          order_key: "desc",
        },
      };

      this.getData(data_params)
        .then((response) => {
          this.form_update = response.data;
          this.getImageFromServer(this.form_update.id);
          console.log('form update', this.form_update)
          // if (this.form_update.gender == 0) {
          //   this.form_update.gender = this.genderTmp[2];
          // }
          // if (this.form_update.gender == 1) {
          //   this.form_update.gender = this.genderTmp[0];
          // }
          // if (this.form_update.gender == 2) {
          //   this.form_update.gender = this.genderTmp[1];
          // }
          // if (this.form_update.dni !== null || '' || undefined) {
          //   this.seleccionarOpcion();
          // }


          if (!this.form_update.birthdate) {
            const date = new Date();
            const formattedDate = `${date.getFullYear()}-${(
              "0" +
              (date.getMonth() + 1)
            ).slice(-2)}-${("0" + date.getDate()).slice(-2)} ${(
              "0" + date.getHours()
            ).slice(-2)}:${("0" + date.getMinutes()).slice(-2)}:${(
              "0" + date.getSeconds()
            ).slice(-2)}`;
            this.form_update.birthdate = formattedDate;
          } else {
            this.form_update.birthDate = new Date(this.form_update.birthDate);
            this.form_update.birthDate.setHours(this.form_update.birthDate.getHours() + this.form_update.birthDate.getTimezoneOffset() / 60);
            console.log(this.form_update.birthdate);
          }
          this.loaded = true;
        })
        .catch((error) => {
          this.loaded = true;
          console.log(error);
        });
    },
    returnUrl() {
      this.$router.go(-1);
    },
    changeStatus(data) {
      let active = data.active === 1 ? 0 : 1;
      let title = data.active === 1 ? "Desactivar" : "Activar";
      let title2 = data.active === 1 ? "Desactivado" : "Activado";
      let text =
        data.active === 1
          ? "¿Estás seguro de desactivarlo ahora?"
          : "¿Estás seguro de activarlo ahora?";
      Swal.fire({
        title: title,
        text: text,
        icon: "question",
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#AA1E2E",
        cancelButtonColor: "#abb2ba",
        confirmButtonText: "Cambiar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          let form = {
            id: data.id,
            url: "user/change_status",
            status: active,
          };
          this.changeStatusData(form)
            .then((response) => {
              if (response.code === 200) {
                this.loadElements();
                data.active = active;
                Swal.fire({
                  title: title2,
                  icon: "success",
                });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
    updatePassword() {

      if (this.form_update.password !== this.form_update.password2) {
        Swal.fire({
          title: "¡Atención!",
          text: "Las contraseñas no coinciden",
          icon: "warning",
          showConfirmButton: false,
          showLoaderOnConfirm: true,
          timer: 1500,
        });
        return;
      }
      Swal.fire({
        title: "¡Atención!",
        text: "¿Estás seguro de actualizar la contraseña de este Usuario?",
        icon: "question",
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#AA1E2E",
        cancelButtonColor: "#9F9F9F",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Sí, guardar",
      }).then((result) => {
        if (result.value) {
          let data_form;
        
            data_form = {
           
              password: this.form_update.password,
            
            };
          

          this.deleting = true;
          let form = {
            url: "user/update",
            id: this.form_update.id,
            data: data_form,
          };
          this.updateData(form)
            .then((response) => {
              if (response.code === 200) {
                this.deleting = false;
                Swal.fire({
                  title: "Contraseña actualizada correctamente",
                  icon: "success",
                  showConfirmButton: false,
                  showLoaderOnConfirm: true,
                  timer: 1000,
                });

                this.$router.push({ name: "Users" });
              }
            })
            .catch((error) => {
              console.log(error);
              this.deleting = false;
              alert("Ocurrió un error, intente más tarde");
            });
        }
      });
    },
     adjustBackgroundHeight() {
      const content = this.$refs.contentOverlay;
      const background = this.$refs.backgroundImage;
      if (content && background) {
        background.style.height = `${content.offsetHeight}px`;
      }
    },
  },
};
</script>
<style>
.datepicker-container {
  width: 100%;
}

input.mx-input {
  border: none;
}

.form-control:hover {
  box-shadow: #AA1E2E;
  border-color: #AA1E2E;
}
.swal2-styled.swal2-default-outline:focus {
  box-shadow: 0 0 0 0px !important;
}
.profile-image {
 
 
  border-radius: 0%;

  overflow: hidden;
}

 .profile-image-default {
  width: 52%; 
  height: 35%;
  object-fit: cover;
}
.profile-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border: 9px solid #AA1E2E;
}

.background-image {
  background-image: url('../../public/img/fondoconsagradas.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
  padding: 20px 0; 
}
.main-container {
  max-width: 480px;
  margin: 0 auto; 
  background-color: white; 
}
.name {
  color: #ab2d2d;
}

.page {
  margin: 0;
  padding: 0;
  page-break-before: auto;
  page-break-after: auto;
  page-break-inside: auto;
}


</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
